export default __webpack_public_path__ + "static/Public-Cloud-d57ec2fbd4b30bc36eacc7cbdb5e4562.webp";